/**
 * [AB#1030] Registro estruturado de erro de render capturado por `ErrorBoundary`.
 *
 * O front não tem logger próprio — vai pro `console.error` em JSON de uma linha (fácil de achar no
 * DevTools e de coletar quando houver um agregador). Só campos NÃO sensíveis: rota SEM query string/
 * hash (podem carregar filtro/termo de busca do usuário), ids do usuário e do tenant, nome do erro,
 * mensagem truncada e as primeiras linhas da pilha de COMPONENTES (nomes de componente, não dados).
 * Nunca registra o objeto de erro inteiro, props, estado, token nem dados de formulário.
 */
export interface ContextoErroTela {
  /** `location.pathname` — sem `search`/`hash`. */
  rota: string;
  usuario_id: number | null;
  tenant_id: number | null;
}

const MAX_MENSAGEM = 200;
const MAX_LINHAS_PILHA = 4;

/** `tenant_id` do payload do JWT (não é segredo; só decodifica, não valida). `null` se ilegível. */
export function tenantIdDoToken(token: string | null | undefined): number | null {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as {
      tenant_id?: unknown;
    };
    return typeof json.tenant_id === 'number' ? json.tenant_id : null;
  } catch {
    return null;
  }
}

export function registrarErroDeTela(
  erro: unknown,
  componentStack: string | null | undefined,
  contexto: ContextoErroTela,
): void {
  const e = erro instanceof Error ? erro : new Error(String(erro));
  const registro = {
    evento: 'erro_de_tela',
    rota: contexto.rota,
    usuario_id: contexto.usuario_id,
    tenant_id: contexto.tenant_id,
    erro: e.name,
    mensagem: e.message.slice(0, MAX_MENSAGEM),
    componentes: (componentStack ?? '')
      .split('\n')
      .map((l) => l.trim())
      .filter(Boolean)
      .slice(0, MAX_LINHAS_PILHA),
  };
  console.error(`[erro_de_tela] ${JSON.stringify(registro)}`);
}
